/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Sidebar, Text } from "@nordcloud/gnui";
import { EditButton } from "~/components/InlineEdit";
import FlexContainer from "~/components/Styled/FlexContainer";
import {
  AssignmentRule,
  CapacityBasedFeeTypeEnum,
} from "~/models/assignmentRule";
import { displayLevel } from "~/tools";
import { toPercentage } from "~/tools/utils/toPercentage";
import { ARServiceLevel } from "./ARServiceLevel";
import { AssignmentRuleServiceLevelClear } from "./AssignmentRuleServiceLevelClear";

type InlineServiceLevelARProps = {
  assignmentRule: AssignmentRule;
  refetch: () => Promise<void>;
  canEdit?: boolean;
};

function InlineServiceLevelAR({
  assignmentRule,
  refetch,
  canEdit = true,
}: InlineServiceLevelARProps) {
  const [isEditMode, setIsEditMode] = React.useState(false);

  const effectiveFee =
    assignmentRule?.attachedServiceLevel?.effectiveCapacityBasedPercentageFee;

  const capacityFeeType =
    assignmentRule?.attachedServiceLevel?.capacityBasedFeeType;

  return (
    <>
      <FlexContainer justify="center" align="center">
        <Text tag="div" mr="0.5rem">
          {displayLevel(
            assignmentRule?.attachedServiceLevel?.serviceLevel?.name
          )}
        </Text>
        {effectiveFee && (
          <Text tag="div" mr="0.5rem">
            Capacity Based Fee:{" "}
            {capacityFeeType ===
            CapacityBasedFeeTypeEnum.INCLUDED_IN_BASE_FEE_TYPE
              ? "Included In Base Fee"
              : `${toPercentage(effectiveFee)} %`}
          </Text>
        )}
      </FlexContainer>
      {canEdit && <EditButton onClick={() => setIsEditMode(true)} />}
      {assignmentRule.attachedServiceLevel && (
        <AssignmentRuleServiceLevelClear
          assignmentRule={assignmentRule}
          refetch={refetch}
        />
      )}
      <Sidebar
        isOpen={isEditMode}
        title="Edit Service Level"
        onClick={() => setIsEditMode(false)}
      >
        <ARServiceLevel
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
          assignmentRule={assignmentRule}
          refetch={refetch}
        />
      </Sidebar>
    </>
  );
}

export { InlineServiceLevelAR };
